import { useNavigate } from "react-router-dom";
import { BrandButton } from "../components/form/buttons";
import "./payconfirm.scss";

const PayConfirm = () => {
  const navigate = useNavigate();

  return (
    <div className="payConfirmPage">
      <div className="headline">
        <h1>Payment Confirmation</h1>
        <div className="description">Thank you for your payment!</div>
      </div>
      <div className="body">
        <BrandButton onClick={() => navigate("/dashboard")}>
          Continue
        </BrandButton>
      </div>
    </div>
  );
};

export default PayConfirm;
